import React, { Component } from 'react'

const projects = [
  {
    title: 'Formula SAE Car Aerodynamic Analysis',
    tech: 'OpenFOAM · C++ · Bash',
    description: 'Adjoint shape analysis on the rear wing of the Queen\'s Formula SAE car — thousands of simulated wing modifications to increase downforce with minimal drag penalty.'
  },
  {
    title: 'Kingston Transit Signal Priority Analysis',
    tech: 'C',
    description: 'Led development of a program simulating the installation of a Transit Signal Priority system on Kingston Transit buses — calculating the impact on travel times and CO2 emissions for both the buses and surrounding traffic.'
  },
  {
    title: 'GroupSwing',
    tech: 'React Native · Expo · TypeScript · Firebase',
    description: 'A golf app for scoring rounds with friends — shared scorecards and group leaderboards, backed by Firebase with cloud functions and a Jest test suite. Currently in development.'
  }
]

export default class Projects extends Component {
  render() {
    return (
      <div>
        <section className="colorlib-work" data-section="projects">
          <div className="colorlib-narrow-content">
            <div className="row">
              <div className="col-md-6 col-md-offset-3 col-md-pull-3 animate-box" data-animate-effect="fadeInLeft">
                <span className="heading-meta">My Work</span>
                <h2 className="colorlib-heading">Projects</h2>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                {projects.map((project) => (
                  <div className="project-entry" key={project.title}>
                    <h3>{project.title} <span>{project.tech}</span></h3>
                    <p>{project.description}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>
      </div>
    )
  }
}
